import { ReactElement } from 'react';

import { IntroSection } from 'src/components/Layout/IntroSection';
import { SupportingText } from 'src/components/Layout/SupportingText';
import DescriptionRowCode from 'src/components/description-row-code';
import FooterExtension from 'src/components/footer-extension';
import PageHeader from 'src/components/headers/page-header';
import SocialProof from 'src/components/social-proof';

import { Locales } from 'src/lib/constants';

import {
  descriptionRowCodeData,
  footerExtensionData,
  introSectionData,
  metaData,
  pageHeaderData,
  socialProofData,
  supportingTextData,
} from 'src/store/use-cases/lending/lending-guide.js';

import { UseCaseTemplate } from 'src/templates';

const LendingGuide = ({
  locale = Locales.EN_US,
}: {
  locale: string;
}): ReactElement => {
  return (
    <UseCaseTemplate fields={metaData} locale={locale}>
      <PageHeader {...pageHeaderData} />
      <SocialProof {...socialProofData} />
      <IntroSection {...introSectionData} />
      <SupportingText {...supportingTextData} />
      <DescriptionRowCode {...descriptionRowCodeData} />
      <FooterExtension {...footerExtensionData} />
    </UseCaseTemplate>
  );
};

LendingGuide.displayName = 'LendingGuide';
export default LendingGuide;
